import { _ } from "~/i18n";
import { IMapyBoxItem } from "~/interfaces";
import { getImage80x52 } from "~/util/cdn";
import { icon, node } from "~/util/dom";
import { getRouteSubtitle, getCriterion } from "~/util/route";
import { timeWithUserSpeed } from "~/util/user-speed";

interface IReplaceItem {
	data: IMapyBoxItem;
}

// vytvorit poznamku
export function createMyMapsReplaceItem({
	data,
}: IReplaceItem) {
	const container = node("div", { className: "mymaps-replace-item" });
	const leftPart = node("div", { className: "mymaps-replace-item__leftPart" });
	const rightPart = node("div", { className: "mymaps-replace-item__rightPart" });
	const desc = node("div", { className: "mymaps-replace-item__desc" });
	const title = node("h2", { className: "mymaps-replace-item__title", textContent: data.usertitle || data.title });
	const subtitle = node("h3", { className: "mymaps-replace-item__subTitle", textContent: data.type === "route" && data.data ? getRouteSubtitle(data.data.totalLength, timeWithUserSpeed(data.data.totalTime, getCriterion())) : data.subtitle });
	const savedLocation = node("h3", { className: "mymaps-replace-item__savedLocation" });

	if (data.liketype && data.liketype !== "like" && data.liketype !== "link") {
		savedLocation.textContent = data.liketype === "home"
			? _("detail.content.mymapsplace.savedHome")
			: _("detail.content.mymapsplace.savedWork");
	} else {
		savedLocation.textContent = `${_("detail.content.mymapsplace.savedInFolder")} ${data.parent_name}`;
	}

	if (data.img) {
		const img = new Image();

		img.classList.add("mymaps-replace-item__image");
		img.src = getImage80x52(data.img);
		leftPart.append(img);
	} else {
		leftPart.append(icon("star-line"));
	}

	desc.append(title, subtitle);
	rightPart.append(desc, savedLocation);
	container.append(leftPart, rightPart);

	return container;
}
